import LookerEmbedTab from 'components/LookerEmbedTab'
import React from 'react'

const DASHBOARD_PATH = 'dashboards/478'

const EngagedCustomersPerLocationTab: React.FC = () => (
  <LookerEmbedTab
    path={DASHBOARD_PATH}
    translationKey="looker.urls.dashboards/478"
  />
)

export default EngagedCustomersPerLocationTab
